<template>
  <v-app>
    <Navbar />
    <v-main>
      <v-container fluid> <router-view /> </v-container>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
  },
  // Uygulama ilk yüklendiğinde token varsa kullanıcıyı çekmeyi deneyebiliriz
  created() {
    this.$store.dispatch('auth/tryAutoLogin');
  }
};
</script>

<style>
/* Genel stiller buraya eklenebilir */
</style>